import { CompositionGrid as CompositionGridComponent } from './CompositionGrid.component';
import { connector } from './CompositionGrid.connector';

export const CompositionGrid = connector(CompositionGridComponent);
